import { render } from "./AssessmentDialog.vue?vue&type=template&id=675e28b3&scoped=true"
import script from "./AssessmentDialog.vue?vue&type=script&lang=js"
export * from "./AssessmentDialog.vue?vue&type=script&lang=js"

import "./AssessmentDialog.vue?vue&type=style&index=0&id=675e28b3&lang=scss"
import "./AssessmentDialog.vue?vue&type=style&index=1&id=675e28b3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-675e28b3"

export default script